module.exports = __webpack_public_path__ + "img/guidelines-01.c2ac75e5.png";